import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqs = [
  {
    q: "What is a Padel Americano tournament?",
    a: "An Americano is a rotating-partners format where every player teams up with different partners across rounds. Rallie handles all rotations automatically — no spreadsheets, no clipboards.",
  },
  {
    q: "How many players can I run per tournament?",
    a: "Rallie supports Americano tournaments from 4 to 32 players. Add players from the community directory or drop in guests instantly.",
  },
  {
    q: "Do I need internet to score a live match?",
    a: "You can score matches offline. Stats and standings sync automatically when your device is back online.",
  },
  {
    q: "Which match formats are supported?",
    a: "Best of 1, 3, 5 or 7 sets, with optional Golden Point. Standard padel scoring — 0-15-30-40, Deuce and Advantage — is fully supported.",
  },
  {
    q: "Is Rallie really free?",
    a: "Yes. All core features — tournaments, live scoring, stats and community — are free forever. A future Pro tier will unlock club-grade tools.",
  },
  {
    q: "Where can I download Rallie?",
    a: "Rallie is available on the App Store for iOS and on Google Play for Android.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 md:py-24 border-t border-neutral-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-24">
            <div className="text-xs uppercase tracking-widest text-[#D4F34A] mb-3">
              FAQ
            </div>
            <h2
              data-testid="faq-heading"
              className="font-display uppercase tracking-tight text-5xl md:text-6xl leading-[0.9]"
            >
              Straight
              <br />
              answers.
            </h2>
            <p className="mt-6 text-neutral-400 text-sm max-w-xs">
              Something else? Reach us at
              <a
                href="mailto:hello@rallie.app"
                className="text-[#D4F34A] hover:underline ml-1"
                data-testid="faq-contact-email"
              >
                hello@rallie.app
              </a>{" "}
              or open a{" "}
              <a
                href="/support"
                data-testid="faq-support-link"
                className="text-[#D4F34A] hover:underline"
              >
                support ticket
              </a>
              .
            </p>

            <div className="mt-10 hidden lg:block border border-neutral-900 p-6 bg-neutral-950 max-w-xs">
              <div className="text-[10px] uppercase tracking-widest text-neutral-500 mb-2">
                Ready when you are
              </div>
              <div className="font-display uppercase text-2xl leading-tight mb-4">
                Take Rallie to the court.
              </div>
              <a
                href="#download"
                data-testid="faq-cta-download"
                className="inline-block bg-[#D4F34A] text-black font-display uppercase text-xs tracking-widest px-4 py-2.5 rounded-full hover:bg-white transition"
              >
                Download the app
              </a>
            </div>
          </div>
        </div>

        <div className="lg:col-span-8 divide-y divide-neutral-900 border-y border-neutral-900">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                >
                  <span className="font-display uppercase text-lg md:text-2xl tracking-tight leading-tight group-hover:text-[#D4F34A] transition">
                    {f.q}
                  </span>
                  <span
                    className={`flex-none w-9 h-9 rounded-full border flex items-center justify-center transition ${
                      isOpen
                        ? "bg-[#D4F34A] text-black border-[#D4F34A]"
                        : "border-neutral-700 text-neutral-400"
                    }`}
                  >
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                {isOpen && (
                  <div
                    data-testid={`faq-answer-${i}`}
                    className="pb-6 pr-14 text-neutral-400 text-sm md:text-base leading-relaxed"
                  >
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
